
// import React from 'react'
// import { useSelector } from 'react-redux';
// import {Box, Grid, Typography,styled,Button} from'@mui/material'
// import CartItem from './cartItem';
// import TotalView from './TotalView';
// import EmptyCart from './EmptyCart';




// const Container=styled(Grid)(({theme})=>({
//   padding:'30px 135px',
//   [theme.breakpoints.down('md')]:{
//    paddding:'15px 0'
//   }
// }))
  


// ;

// const Header=styled(Box)`
//  padding: 15px 24px;
//  background:#fff;
// `;

// const ButtonWrapper=styled(Box)`
//     padding:16px 22px;
//     background:#fff;
//     box-shadow:0 -2px 10px 0 rgb(0 0 0/10%);
//     border-top:1px solid #f0f0f0;

// `
// const StyledButton=styled(Button)`
//   display:flex;
//   margin-left:auto;
//   background:#fb641b;
//   color:#fff;
//   width:250px;
//   height:51px;
//   border-radius:2px;
// `;
// const LeftComponent=styled(Grid)(({theme})=>({
//   paddingRight:15,
//   [theme.breakpoints.down('md')]:{
//     marginBottom:15
//   }

// }));





// const Cart = () => {
//     console.log("nfoo")
//   const {cartItems}=useSelector(state=>state.cart); 
//    return (
//     <>
//     <div style={{marginTop:'35px',marginLeft:'1px'}}>
//       {
//        cartItems.length?
//          <Container container>
//              <LeftComponent item lg={9} md={9} sm={12} xs={12}>
//               <Header>
//               <Typography>
//                 my cart({cartItems.length})
//               </Typography>
//               </Header>

//               {
//                 cartItems.map(item=>(
//                    <CartItem item={item}/>
//                 ))
//               }
//               <ButtonWrapper>
//                 <StyledButton onClick={() => buyNow()}>Place Order</StyledButton>
//               </ButtonWrapper>
//              </LeftComponent>
//              <Grid item lg={3} mf={3} sm={12} xs={12}>
//                     <TotalView cartItems={cartItems}/>
//              </Grid>
//          </Container>:<EmptyCart/>
//      }
//      </div>
//     </>
//   )
// }

// export default Cart;








import { useEffect,useState } from 'react';

import { Box, Typography, Button, Grid, styled } from '@mui/material';
import { useParams } from 'react-router-dom';

import { useSelector, useDispatch } from 'react-redux';
import { addToCart, removeFromCart } from '../redux/actions/cartActions';

import TotalView from './TotalView';
import EmptyCart from './EmptyCart';
import CartItem from './cartItem';


import { showRazorpay } from '../../service/api';


const Component = styled(Grid)(({ theme }) => ({
    padding: '30px 135px',
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
        padding: '15px 0'
    }
}));

const LeftComponent = styled(Grid)(({ theme }) => ({
    paddingRight: 15,
    [theme.breakpoints.down('sm')]: {
        marginBottom: 15
    }
}));

const Header = styled(Box)`
    padding: 15px 24px;
    background: #fff;
`;

const BottomWrapper = styled(Box)`
    padding: 16px 22px;
    background: #fff;
    box-shadow: 0 -2px 10px 0 rgb(0 0 0 / 10%);
    border-top: 1px solid #f0f0f0;
`;

const StyledButton = styled(Button)`
    display: flex;
    margin-left: auto;
    background: #fb641b;
    color: #fff;
    border-radius: 2px;
    width: 250px;
    height: 51px;
`;

const Cart = () => {
    const cartDetails = useSelector(state => state.cart);
    const { cartItems } = cartDetails;
    const { id } = useParams();

    const [price, setPrice] = useState(0);
    const [discount, setDiscount] = useState(0)
    const [dueamount, setAmount] = useState(0)
    
  

    const dispatch = useDispatch();
    
    useEffect(() => {
        if(cartItems && id !== cartItems.id)   
            dispatch(addToCart(id));
    }, [dispatch, cartItems, id]);

    const removeItemFromCart = (id) => {
        dispatch(removeFromCart(id));
    }
    useEffect(() => {
        totalAmount();
    }, [cartItems]);
    
    const totalAmount = () => {
        let price = 0, discount = 0;
        cartItems.map(item => {
            price += item.price.mrp*item.quantity
            discount += (item.price.mrp - item.price.cost)*item.quantity 
        })
        setPrice(price);
        setDiscount(discount);
        setAmount(price-discount+40);
    }
    // const totalamount =price-discount+40;

//  console.log(totalamount);
console.log(dueamount);

  

    return (
        <>
        { cartItems.length ? 
            <Component container>
                <LeftComponent item lg={9} md={9} sm={12} xs={12}>
                    <Header>
                        <Typography style={{fontWeight: 600, fontSize: 18}}>My Cart ({cartItems?.length})</Typography>
                    </Header>
                        {   cartItems.map(item => (
                                <CartItem item={item} removeItemFromCart={removeItemFromCart}/>
                            ))
                        }
                    <BottomWrapper>
                        <StyledButton onClick={() => showRazorpay(dueamount)} variant="contained">Place Order</StyledButton>
                    </BottomWrapper>
                </LeftComponent>
                <Grid item lg={3} md={3} sm={12} xs={12}>
                    <TotalView cartItems={cartItems} />
                </Grid>
            </Component> : <EmptyCart />
        }
        </>

    )
}

export default Cart;